// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TarifsSoinsRouteImport } from './routes/tarifs-soins'
import { Route as TarifsRouteImport } from './routes/tarifs'
import { Route as SoinsEnergetiquesToulouseRouteImport } from './routes/soins-energetiques-toulouse'
import { Route as PrestationsRouteImport } from './routes/prestations'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as MassageEnergetiqueToulouseRouteImport } from './routes/massage-energetique-toulouse'
import { Route as EnergeticienneToulouseRouteImport } from './routes/energeticienne-toulouse'
import { Route as EnergeticienneFonsorbesRouteImport } from './routes/energeticienne-fonsorbes'
import { Route as DeontologieRouteImport } from './routes/deontologie'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CgvRouteImport } from './routes/cgv'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AProposRouteImport } from './routes/a-propos'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TarifsSoinsRoute = TarifsSoinsRouteImport.update({
            id: '/tarifs-soins',path: '/tarifs-soins',getParentRoute: () => rootRouteImport
          })
const TarifsRoute = TarifsRouteImport.update({
            id: '/tarifs',path: '/tarifs',getParentRoute: () => rootRouteImport
          })
const SoinsEnergetiquesToulouseRoute = SoinsEnergetiquesToulouseRouteImport.update({
            id: '/soins-energetiques-toulouse',path: '/soins-energetiques-toulouse',getParentRoute: () => rootRouteImport
          })
const PrestationsRoute = PrestationsRouteImport.update({
            id: '/prestations',path: '/prestations',getParentRoute: () => rootRouteImport
          })
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
            id: '/mentions-legales',path: '/mentions-legales',getParentRoute: () => rootRouteImport
          })
const MassageEnergetiqueToulouseRoute = MassageEnergetiqueToulouseRouteImport.update({
            id: '/massage-energetique-toulouse',path: '/massage-energetique-toulouse',getParentRoute: () => rootRouteImport
          })
const EnergeticienneToulouseRoute = EnergeticienneToulouseRouteImport.update({
            id: '/energeticienne-toulouse',path: '/energeticienne-toulouse',getParentRoute: () => rootRouteImport
          })
const EnergeticienneFonsorbesRoute = EnergeticienneFonsorbesRouteImport.update({
            id: '/energeticienne-fonsorbes',path: '/energeticienne-fonsorbes',getParentRoute: () => rootRouteImport
          })
const DeontologieRoute = DeontologieRouteImport.update({
            id: '/deontologie',path: '/deontologie',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CgvRoute = CgvRouteImport.update({
            id: '/cgv',path: '/cgv',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AProposRoute = AProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AProposRoute: AProposRoute,BlogRoute: BlogRouteWithChildren,CgvRoute: CgvRoute,ContactRoute: ContactRoute,DeontologieRoute: DeontologieRoute,EnergeticienneFonsorbesRoute: EnergeticienneFonsorbesRoute,EnergeticienneToulouseRoute: EnergeticienneToulouseRoute,MassageEnergetiqueToulouseRoute: MassageEnergetiqueToulouseRoute,MentionsLegalesRoute: MentionsLegalesRoute,PrestationsRoute: PrestationsRoute,SoinsEnergetiquesToulouseRoute: SoinsEnergetiquesToulouseRoute,TarifsRoute: TarifsRoute,TarifsSoinsRoute: TarifsSoinsRoute,UnsubscribeRoute: UnsubscribeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)